module.exports = __webpack_public_path__ + "img/marker.b1beff60.png";